// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectArr_wrapper__abxCS","title":"SelectArr_title__Hn7TG","select":"SelectArr_select__5KV0h","itemLabel":"SelectArr_itemLabel__carmw"};